<template>
  <div class="account-created text-center">
    <h1 class="title mb-6 mt-3">
      {{ $t('onboarding.createdTitleP1') }}
      <br/>
      {{ $t('onboarding.createdTitleP2') }}
    </h1>

    <ytplayer v-if="!videoEnded" class="mb-10" videoId='4tV4vUSVeck' :points="points" @ended="videoEnded = true"></ytplayer>
    <div v-else class="arrow bounce-arrow"><iconDownArrow /></div>

    <div v-if="showContentAfterVideo">
      <router-link
        class="btn_link"
        :to="$i18nRoute({ name: isSubscribed ? 'settings' : 'subscription' })"
      >
        <button class="submit-btn btn btn--sm btn--warmPink my-7">{{ isSubscribed ? $t('base.continue') : $t('base.startTrial') }}</button>
      </router-link>

      <faq />
    </div>
  </div>
</template>

<script>
import iconDownArrow from '@/static/custom-img/down-arrow.svg';
import ytplayer from '@/components/base/ytplayer';
import faq from '@/components/onboarding/faq';

export default {
  components: {
    faq,
    ytplayer,
    iconDownArrow,
  },

  data () {
    return {
      videoEnded: false,
      player: {},
      playing: false,
      showOverlay: true,
      showContentAfterVideo: false,
      tag: {
        780: false,
        120: false,
        1: false,
      },
    };
  },

  computed: {
    user () {
      return this.$store.state.user.data.data;
    },

    isSubscribed () {
      return this.user.isSubscribed && this.user.subscription;
    },

    points () {
      return [
        {
          time: process.env.VUE_APP_ENV === 'dev' ? 10 : 740,
          cb: () => {
            if (!this.showContentAfterVideo) {
              this.showContentAfterVideo = true;
            }
          },
        },
        {
          time: 1,
          cb: async () => {
            if (!this.tag[1]) {
              this.tag[1] = true;
              await this.$store.dispatch(
                'user/ADD_CONTACT_TAG',
                'Action: Watched Frontend VSL (>0:01)',
              );
            }
          },
        },
        {
          time: 120,
          cb: async () => {
            if (!this.tag[120]) {
              this.tag[120] = true;
              await this.$store.dispatch(
                'user/ADD_CONTACT_TAG',
                'Action: Watched Frontend VSL (>2:00)',
              );
            }
          },
        },
        {
          time: 780,
          cb: async () => {
            if (!this.tag[780]) {
              this.tag[780] = true;
              await this.$store.dispatch(
                'user/ADD_CONTACT_TAG',
                'Action: Watched Frontend VSL (>13:00)',
              );
            }
          },
        },
      ];
    },
  },

  methods: {
    async play () {
      if (this.playing) return;

      this.playing = true;
      await this.player.play();
      this.playing = false;
      this.showOverlay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-over {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  width: 100%;
  background: rgba(0,0,0,0.8);

  span {
    margin: auto;
    color: #FFF;
    font-weight: bold;
    font-size: 2.5em;
    cursor: pointer;
  }
}

.title {
  color: #44445E;
  font-weight: bold;
  text-align: center;
  letter-spacing: -0.175px;
  font-size: 26px !important;
  line-height: 32px !important;
  max-width: 600px;
  margin: auto;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 18px !important;
    line-height: 28px !important;
  }
}

.submit-btn {
  width: 100%;
  max-width: 425px;
  margin: auto;
  font-weight: bold;
  font-size: 26px;
  line-height: 26px;
  letter-spacing: 0.2px;
  height: 80px;
  white-space: pre-line;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 18px !important;
    line-height: 28px !important;
  }
}

.arrow {
  svg {
    width: 280px;
    height: 210px;
  }
}
</style>
